import {Link, ModalLink, roles, trackAnalyticsEvent} from '@eitje/bridge'
import utils from '@eitje/utils'
import {Icon, Text, Layout, ExternalLink} from '~/components'

export const DropdownItemLayout = ({
	t,
	iconLeft,
	leftElement,
	iconRight,
	countSuffix,
	to,
	modalLink,
	externalLink,
	onClick,
	infoIconMessage,
	children,
	disabled,
	className,
	...layoutProps
}) => {
	const {enableRole, roleEnv, analytics, ...otherLayoutProps} = layoutProps
	const isDisabledByRole = roles.useRoleMessage({roles: enableRole, env: roleEnv})
	const isDisabled = isDisabledByRole || disabled

	const handleClick = e => {
		if (trackAnalyticsEvent && analytics) {
			trackAnalyticsEvent(analytics)
		}

		onClick?.(e)
	}

	const content = (
		<Layout
			disabled={isDisabled}
			className={utils.makeCns(className, 'dropdown-item')}
			colorSet
			padding="8 16"
			gap={8}
			height={40}
			{...otherLayoutProps}
			// Should have hover styling if its wrapper is clickable
			hasHover={Boolean(onClick) || to || modalLink || externalLink}
		>
			{iconLeft && <Icon className={`icon-${iconLeft}-left`} name={iconLeft} size={16} />}
			{leftElement}
			<Text t={t} countSuffix={countSuffix} style={{flex: 1}} noTextSelect infoIconMessage={infoIconMessage} truncate hideTruncateTooltip>
				{children}
			</Text>
			{iconRight && <Icon className={`icon-${iconRight}-right`} name={iconRight} size={16} />}
		</Layout>
	)

	if (to)
		return (
			<Link to={to} disabled={isDisabled} className="dropdown-item-wrapper" onClick={handleClick}>
				{content}
			</Link>
		)

	if (modalLink)
		return (
			<ModalLink to={modalLink} disabled={isDisabled} className="dropdown-item-wrapper" onClick={handleClick}>
				{content}
			</ModalLink>
		)

	if (externalLink)
		return (
			<ExternalLink to={externalLink} className="dropdown-item-wrapper" disabled={isDisabled} onClick={handleClick}>
				{content}
			</ExternalLink>
		)

	return (
		<div className="dropdown-item-wrapper" onClick={isDisabled ? undefined : handleClick}>
			{content}
		</div>
	)
}
